import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { Avatar, Typography } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { actions } from '../store/storeAuth.js';
import loginService from '../services/login';
import { defaultErrorMsg } from '../helpers/rsuite/Alerts';
import Password from '../constants/logins/password';
import Users from '../constants/logins/users';
import { alertError } from '../helpers';
import Button from '../components/button/Button.jsx';
import Input from '../components/input/Input.jsx';

export function Login (props) {
    const dispatch = useDispatch();
    const history = useHistory();

    const [loading, setLoading] = useState(false);
    const [showAlert, setShowAlert] = useState(true);

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const [usernameError, setUsernameError] = useState('');
    const [passwordError, setPasswordError] = useState('');

    function validateUsername (value) {
        if (!value) {
            setUsernameError('El campo es obligatorio');
            return false;
        }
        /*
        if (value.length < 4) {
            setUsernameError('El nombre de usuario debe tener al menos cuatro caracteres.');
            return false;
        }
        */
        setUsernameError('');
        return true;
    };

    function validatePassword (value) {
        if (!/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[[\]/#=?!@$%^&{}()|*+.:,;`'~_-]).{8,}$/.test(value)) {
            setPasswordError('La contraseña debe tener entre 8 y 20 caracteres, al menos una letra mayúscula, un número y un carácter especial.');
            return false;
        }
        if (value.length < 8) {
            setPasswordError('La contraseña debe tener entre 8 y 20 caracteres, al menos una letra mayúscula, un número y un carácter especial.');
            return false;
        }
        if (value.length > 20) {
            setPasswordError('La contraseña debe tener entre 8 y 20 caracteres, al menos una letra mayúscula, un número y un carácter especial.');
            return false;
        }
        setPasswordError('');
        return true;
    }

    function validate () {
        const isUsernameValid = validateUsername(username);
        const isPasswordValid = validatePassword(password);

        if (!isUsernameValid) return false;
        if (!isPasswordValid) return false;

        return true;
    }

    async function submit (event) {
        event.preventDefault();
        try {
            if (!validate()) return false;

            setLoading(true);

            const user = await loginService.login({
                payload: {
                    key: username,
                    password: password,
                },
            });

            localStorage.removeItem('store');
            localStorage.removeItem('loan_status_changes');
            localStorage.setItem('sessionUser', JSON.stringify(user));

            dispatch(actions.login({
                token: user.token.access_token,
                user
            }));

            setLoading(false);

            history.push('/dashboard');
        }
        catch (error) {
            console.error(error);
            setLoading(false);

            const errorData = error?.response?.data;
            const keyStatus = errorData?.extra?.key;

            if (keyStatus === Password.recovery) {
                setLoading(false);
                localStorage.setItem('idUser', errorData?.extra?.user?.id);
                localStorage.setItem('pass', password);
                history.push('/auth/change-password');
                return;
            }

            if (keyStatus === Password.invalid) {
                return alertError('La contraseña o el usuario ingresado es incorrecto.', showAlert, setShowAlert);
            }

            if (keyStatus === Password.blocked || keyStatus === Users.blocked) {
                return alertError('Su usuario se ha bloqueado. Por favor contacte al administrador.', showAlert, setShowAlert);
            }

            return alertError(defaultErrorMsg, showAlert, setShowAlert);
        }
    }

    return (
        <main>
            <Avatar>
                <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
                Log in
            </Typography>
            <form id="login-form" onSubmit={submit}>
                <Input
                    required
                    name="username"
                    label="Usuario"
                    value={username}
                    error={usernameError}
                    onChange={setUsername}
                    onBlur={validateUsername}
                />
                <Input
                    required
                    type="password"
                    name="password"
                    label="Contraseña"
                    value={password}
                    error={passwordError}
                    onChange={setPassword}
                    onBlur={validatePassword}
                />
            </form>
            <Button type="submit" form="login-form" loading={loading} block>
                Iniciar Sesion
            </Button>
        </main>
    );
};

export default Login;
